import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./RosaI.css";

import rosasc from "./Images/SC.gif";
import captureButton from "./Images/capture.png";
import backButton from "./Images/back.png";

const RosaSc = () => {
  const navigate = useNavigate();
  const userEmail = sessionStorage.getItem("userEmail");

  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [extractedText, setExtractedText] = useState("");
  const [folderName, setFolderName] = useState("");
  const [loading, setLoading] = useState(false);

  /* -------------------------------
     AUTH CHECK
  --------------------------------*/
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  /* -------------------------------
     FETCH FOLDER NAME
  --------------------------------*/
  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const res = await fetch("https://www.d-rosa.ai/appname");
        const data = await res.json();
        setFolderName(data.foldername || "default");
      } catch (err) {
        console.error("Folder fetch error:", err);
      }
    };
    fetchFolderName();
  }, []);

  /* -------------------------------
     CAMERA INIT
  --------------------------------*/
  useEffect(() => {
    const startCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" }
        });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      } catch (err) {
        console.error("Camera error:", err);
      }
    };
    startCamera();
  }, []);

  /* -------------------------------
     CAPTURE + UPLOAD IMAGE
  --------------------------------*/
  const captureImage = async () => {
    if (!videoRef.current || !canvasRef.current) return;

    setLoading(true);
    setExtractedText("");

    const canvas = canvasRef.current;
    const video = videoRef.current;

    canvas.width = video.videoWidth || 300;
    canvas.height = video.videoHeight || 300;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob(async (blob) => {
      if (!blob) {
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("image", blob, "image.png");
      formData.append(
        "path",
        `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`
      );

      try {
        const res = await fetch("https://www.d-rosa.ai/IMGAPI", {
          method: "POST",
          body: formData
        });

        if (!res.ok) throw new Error("Upload failed");

        // Ensure file write completes
        await new Promise((r) => setTimeout(r, 300));

        fetchExtractedText();
      } catch (err) {
        console.error(err);
        alert("Image upload failed");
        setLoading(false);
      }
    }, "image/png");
  };

  /* -------------------------------
     OCR CALL
  --------------------------------*/
  const fetchExtractedText = async () => {
    try {
      const res = await fetch("https://www.d-rosa.ai/pictextapi", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}/image.png`
        })
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message);

      setExtractedText(data.text || "No text detected");
    } catch (err) {
      console.error("OCR error:", err);
      setExtractedText("Failed to extract text");
    } finally {
      setLoading(false);
    }
  };

  /* -------------------------------
     UI
  --------------------------------*/
  return (
    <div>
      <img className="top-left-logo" src={rosasc} alt="Logo" width="80" height="100"/>

      <center>
        <h2 className="center-heading">Welcome Page</h2>
      </center>

      <p>Signed in as: {userEmail}</p>

     <div className="video-container"> 
<video ref={videoRef} autoPlay playsInline muted style={{ width: "300px" }} >
</video> 
<canvas ref={canvasRef} width={300} height={300} style={{ display: "none" }} >
</canvas>
 </div><br /> 
<button type="button" onClick={captureImage}> 
<img src={captureButton} alt="Capture" width="60" height="60" /> 
</button><br /><br />
      {loading && <p>Processing image...</p>}

      <p><b>Extracted Text:</b></p>
      <textarea
        value={extractedText}
        readOnly
        rows={6}
        style={{ width: "80%" }}
      />

      <br /><br />

      <button onClick={() => navigate(-1)}>
        <img src={backButton} alt="Back" width="60" />
      </button>

      <footer className="footer-section">
        <div className="text-6">
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default RosaSc;
